import React from "react";
import styles from "./ApplicantDetailSidebarHeader.module.scss";
import { Icon } from "../../atoms/Icon";
import classnames from "classnames";

export function ApplicantDetailSidebarHeader({ applicant, onDismissSidebar }) {
  return (
    <div className={styles.rightSidebarHeader}>
      <div className={styles.titleContainer}>
        <img className={styles.userImage} src={applicant.picture} />
        <div className={styles.userTitle}>
          <h2>{applicant.name}</h2>
          <span>@{applicant.username}</span>
        </div>
        <Icon
          name="cross"
          size={20}
          className={classnames(styles.exitRightSidebarIcon)}
          onClick={() => onDismissSidebar()}
        />
      </div>
    </div>
  );
}
